var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiscard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47.0133,
    height: 47.0133,
    rx: 4.5,
    fill: "#F7F7F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47.0133,
    height: 47.0133,
    rx: 4.5,
    stroke: "#DBE5E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8398 17.0068H35.6732V19.3401H33.3398V34.5068C33.3398 34.8162 33.2169 35.1129 32.9981 35.3317C32.7793 35.5505 32.4826 35.6734 32.1732 35.6734H15.8398C15.5304 35.6734 15.2337 35.5505 15.0149 35.3317C14.7961 35.1129 14.6732 34.8162 14.6732 34.5068V19.3401H12.3398V17.0068H18.1732V13.5068C18.1732 13.1973 18.2961 12.9006 18.5149 12.6818C18.7337 12.463 19.0304 12.3401 19.3398 12.3401H28.6732C28.9826 12.3401 29.2793 12.463 29.4981 12.6818C29.7169 12.9006 29.8398 13.1973 29.8398 13.5068V17.0068ZM31.0065 19.3401H17.0065V33.3401H31.0065V19.3401ZM20.5065 22.8401H22.8398V29.8401H20.5065V22.8401ZM25.1732 22.8401H27.5065V29.8401H25.1732V22.8401ZM20.5065 14.6734V17.0068H27.5065V14.6734H20.5065Z",
    fill: "#EA4D4D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscard);
export default __webpack_public_path__ + "static/media/discard.f3c204d752e194987e35549b281a46f8.svg";
export { ForwardRef as ReactComponent };